import { render, staticRenderFns } from "./add-document.vue?vue&type=template&id=3dfd4ec9&"
import script from "./add-document.vue?vue&type=script&lang=js&"
export * from "./add-document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports